module.exports = __webpack_public_path__ + "static/media/mc-logo.7aca16a4.svg";